module.exports = __webpack_public_path__ + "static/death_slaad-5219f68ed566bcde97496c7be58cec66.jpeg";